module.exports = __webpack_public_path__ + "static/media/signUpIcon_m.f22761d5.svg";